import './polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { icons } from './assets/icons';
import reportWebVitals from './reportWebVitals';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { store } from './store';
import Alert from './reusable/Alert';
import './App.css';
import './scss/styles.scss';
import './index.css';
import 'react-photo-view/dist/react-photo-view.css';

Chart.register(...registerables, annotationPlugin);

(React as typeof React & { icons?: typeof icons }).icons = icons;

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

createRoot(container).render(
  <Provider store={store}>
    <App />
    <Alert />
  </Provider>
);

reportWebVitals();
